import React from 'react';
import PropTypes from 'prop-types';
import {
  CLIP_MEDIA_VERSIONS,
  CLIP_MEDIA_VERSIONS_ORDER,
  CLIP_MEDIA_VERSION_LABELS,
  CLIP_MEDIA_VERSION_GRADED,
} from '../../constants';
import Button from '../Button';
import { Form } from '../Form';
import { Info } from '../Icons';
import Link from '../Link';
import Style from '../Style';
import { H3, L2, L3, L4, P1, P2 } from '../Typography';

class DownloadVersionPicker extends React.PureComponent {
  static propTypes = {
    alreadyLicensed: PropTypes.bool,
    pastDue: PropTypes.bool,
    selectedVersion: PropTypes.string,
    onPickVersion: PropTypes.func,
    downloadablesFetching: PropTypes.bool,
    downloadables: PropTypes.object,
    onDownloadClip: PropTypes.func,
  };
  static defaultProps = {};

  constructor(props) {
    super(props);

    this.state = {
      formEnabled: true,
      fetching: false,
    };
  }

  doPickVersion = e => {
    this.props.onPickVersion(e.target.value);
  };

  doDownload = () => {
    if (!this.state.formEnabled) {
      return;
    }

    this.setState({ formEnabled: false, fetching: true });
    this.props
      .onDownloadClip()
      .then(() => this.setState({ fetching: false }))
      .catch(() => this.setState({ fetching: false, formEnabled: true }));
  };

  render() {
    const {
      alreadyLicensed,
      pastDue,
      selectedVersion,
      onPickVersion,
      downloadablesFetching,
      downloadables,
      onDownloadClip,
      ...otherProps
    } = this.props;

    const selectedAvailable = downloadables.allVersions.includes(
      selectedVersion,
    );
    const selectedDownloadable = downloadables.downloadableVerions.includes(
      selectedVersion,
    );
    let buttonText = 'Download Now';
    let buttonArrow = false;
    if (selectedAvailable && !selectedDownloadable) {
      buttonText = 'Continue';
      buttonArrow = true;
    }

    let unavailableText = 'AVAILABLE w/ UPGRADE';
    if (pastDue) {
      unavailableText = 'ACCOUNT PAST DUE!';
    }

    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '11rem 4rem 6rem',
        }}
      >
        <H3 style={{ marginBottom: '7rem' }}>
          Download this clip{alreadyLicensed ? ' again' : ''}
        </H3>
        <L2
          style={{
            color: Style.Colors.shadow3,
            marginBottom: '1rem',
            display: 'block',
          }}
        >
          CHOOSE YOUR FORMAT
        </L2>
        <Form
          onSubmit={this.doDownload}
          style={{ alignItems: 'flex-start', paddingLeft: '2rem' }}
        >
          {CLIP_MEDIA_VERSIONS_ORDER.map(version => {
            const available = downloadables.allVersions.includes(version);
            if (!available) {
              return null;
            }

            const text = CLIP_MEDIA_VERSION_LABELS[version];
            const graded = CLIP_MEDIA_VERSION_GRADED[version];
            const canDownload = downloadables.downloadableVerions.includes(
              version,
            );

            return (
              <div key={version} style={{ margin: '1rem 0' }}>
                <input
                  type="radio"
                  id={`download_${version}`}
                  name="version"
                  value={version}
                  onChange={this.doPickVersion}
                  checked={version === selectedVersion}
                  style={{ display: 'none' }}
                />
                <label htmlFor={`download_${version}`}>
                  <P1 style={{ display: 'inline' }}>
                    <span style={{ marginRight: '1rem' }}>
                      <Radio
                        size={'1em'}
                        checked={version === selectedVersion}
                      />
                    </span>
                    {text}
                  </P1>
                  <Info
                    color={Style.Colors.black}
                    style={{
                      maxWidth: '1.6rem',
                      opacity: 0.5,
                      display: graded || true ? 'none' : 'inline',
                    }}
                  />
                  <L4
                    style={{
                      marginLeft: '2rem',
                      opacity: 0.5,
                      fontWeight: 400,
                      display: canDownload ? 'none' : 'inline',
                      letterSpacing: '0.07rem',
                    }}
                  >
                    {unavailableText}
                  </L4>
                </label>
              </div>
            );
          })}
        </Form>
        <div style={{ alignSelf: 'center', marginTop: '8rem' }}>
          <Button
            size="large"
            type="submit"
            arrow={buttonArrow}
            onClick={this.doDownload}
            working={this.state.fetching || downloadablesFetching}
          >
            {buttonText}
          </Button>
        </div>
      </div>
    );
  }
}

export default DownloadVersionPicker;

function Radio({ size, checked }) {
  const containerStyle = {
    fontSize: size,
    display: 'inline-block',
  };

  const borderStyle = {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '1em',
    height: '1em',
    borderRadius: '99999rem',
    border: `0.05em solid ${Style.Colors.black}`,
    backgroundColor: Style.Colors.white,
  };

  const checkStyle = {
    display: 'inline-block',
    width: `${14 / 18}em`,
    height: `${14 / 18}em`,
    borderRadius: '99999rem',
    backgroundColor: checked ? Style.Colors.black : Style.Colors.white,
    padding: '0.111em',
  };

  return (
    <span style={containerStyle}>
      <span style={borderStyle}>
        <span style={checkStyle} />
      </span>
    </span>
  );
}



// WEBPACK FOOTER //
// ./src/components/DownloadVersionPicker/DownloadVersionPicker.js